import { useSelector } from "react-redux";

import { copy } from "shared/assets";
import { IJSONAPIErrorCodes } from "shared/types";
import { dataMetaSelector } from "Bands/state";
import { useAPIError } from "./useAPIError";

const billingInfoCopy = copy.subscription.billingInfo;

export const useInvalidVATError = (action: string) => {
  const { api: apiMeta } = useSelector(dataMetaSelector(action));

  const { error } = useAPIError({
    apiError: apiMeta?.error,
    message: billingInfoCopy.invalidVat,
    errorCode: IJSONAPIErrorCodes.InvalidVAT,
  });

  return { error };
};
